import {ResourceDetails} from '../../types/ResourceDetails';
import {ResourceListForTable} from '../../types/ResourceList';

export function hasContainees(list: ResourceListForTable): boolean {
  for (let item of list.list) {
    if (getContainees(item).length > 0) {
      return true;
    }
  }

  return false;
}

export function getContainees(item: ResourceDetails): ResourceDetails[] {
  if (Array.isArray(item.__containee__)) {
    return item.__containee__;
  }

  return [];
}

export function eachContainee(
  item: ResourceDetails,
  fn: (containee: ResourceDetails) => void,
) {
  for (const containee of getContainees(item)) {
    fn(containee);
  }
}

export function getContaineeIds(item: ResourceDetails): string[] {
  const ids: string[] = [];

  for (let containee of getContainees(item)) {
    ids.push(containee.id);
  }

  return ids;
}
